import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmReports1Route } from '@jira/router-routes__servicedesk-reports-routes/src/csmReports1Route.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { servicedeskReportsHomePageEntrypoint } from '@jira/spa-apps__servicedesk-reports-home-page/src/servicedeskReportsHomePageEntrypoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { getReportsWithKbResources } from './common/getReportsWithKbResources.tsx';

const csmReports1PageEntryPoint = createPageEntryPoint({
	main: servicedeskReportsHomePageEntrypoint,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
		isProjectsExpanded: true,
	},
});

export const csmReports1RouteEntry: Route = createEntry(csmReports1Route, () => ({
	group: 'customer-service',
	layout: serviceProjectLayout,

	navigation: {
		sidebarId: SidebarIdCsmApp,
	},

	resources: [
		...getCustomerServiceL1NavigationResources(),
		...getServiceDeskNavigationResources(),
		...getReportsWithKbResources(),
	],

	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? csmReports1PageEntryPoint
			: notFoundPageEntrypoint;
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
